<template>
  <VCardTitle>
    <slot />
  </VCardTitle>
</template>

<script setup lang="ts">
import { VCardTitle } from 'vuetify/components/VCard';
</script>
